/**
 * Userkey validation utilities
 */

import type { UserkeyRuleStatus, UserkeyValidationResult, UserkeyValidationRule } from "../types/utilityType";


/**
 * Userkey validation rules
 */
export const userkeyValidationRules: UserkeyValidationRule[] = [
  {
    test: (userkey: string) => userkey.length >= 12,
    message: 'Mínimo de 12 caracteres'
  },
  {
    test: (userkey: string) => /[A-Z]/.test(userkey),
    message: 'Mínimo de 1 letra maiúscula'
  },
  {
    test: (userkey: string) => /\d/.test(userkey),
    message: 'Mínimo de 1 número'
  },
  {
    test: (userkey: string) => /[!@#$%^&*(),.?":{}|<>]/.test(userkey),
    message: 'Mínimo de 1 caractere especial'
  },
  {
    test: (userkey: string) => !/(?:[0-9]{3}\.){2}[0-9]{3}-[0-9]{2}|[0-9]{11}/.test(userkey) &&
      !/(?:[A-Za-z]+@[A-Za-z]+\.[A-Za-z]+)/.test(userkey) &&
      !/(?:[A-Za-z]{2,}\s[A-Za-z]{2,})/.test(userkey),
    message: 'Não pode conter dados pessoais'
  }
];

/**
 * Validates a userkey against all defined rules
 * @param userkey - Userkey to be validated
 * @returns Validation result with found errors
 */
export const validateUserkey = (userkey: string): UserkeyValidationResult => {
  const errors: string[] = [];

  userkeyValidationRules.forEach(rule => {
    if (!rule.test(userkey)) {
      errors.push(rule.message);
    }
  });

  return {
    isValid: errors.length === 0,
    errors
  };
};

/**
 * Gets the individual status of each validation rule
 * @param userkey - Userkey to be validated
 * @returns Array with the status of each rule
 */
export const getUserkeyRuleStatuses = (userkey: string): UserkeyRuleStatus[] => {
  return userkeyValidationRules.map(rule => ({
    message: rule.message,
    isValid: rule.test(userkey)
  }));
};

/**
 * Checks if two userkeys match
 * @param userkey - Original userkey
 * @param confirmUserkey - Confirmation userkey
 * @returns true if userkeys match
 */
export const userkeysMatch = (userkey: string, confirmUserkey: string): boolean => {
  return userkey === confirmUserkey && userkey.length > 0 && confirmUserkey.length > 0;
};
